import { Component, input, signal, OnInit, OnDestroy, computed } from '@angular/core';
import { ClientInformation } from 'src/app/models/client-information';
import { Integration } from 'src/app/models/integration';
import { IntegrationIdentifier } from 'src/app/models/integration-identifier';
import { IntegrationInformation } from 'src/app/models/integration-information';
import { Subject } from 'rxjs';
import { MatButtonModule } from '@angular/material/button';
import { FastfetchComponent } from '../fastfetch/fastfetch.component';
import { LBADataswapComponent } from '../lba-dataswap/lba-dataswap.component';

@Component({
  selector: 'app-integration-process-view',
  imports: [
    MatButtonModule,
    FastfetchComponent,
    LBADataswapComponent,
  ],
  templateUrl: './integration-process-view.component.html',
  styleUrl: './integration-process-view.component.scss',
})
export class IntegrationProcessViewComponent implements OnInit, OnDestroy {
  private readonly destroyed$ = new Subject<void>();
  client = input.required<ClientInformation>();
  integration = input.required<Integration>();
  identifiers = input<IntegrationIdentifier[] | []>([]);
  integrationInfo = input<IntegrationInformation[] | []>([]);

  showProcessDataCards = signal<boolean>(true);
  showDataSwap = signal<boolean>(true);
  showFastFetch = signal<boolean>(true);

  computedIntegrationInfo = computed(() => {
    const infoIn = this.integrationInfo();
    return infoIn.length > 0 ? infoIn : this.processedIntegrationInfo();
  });

  private processedIntegrationInfo = computed(() => {
    if (this.identifiers() && this.identifiers()?.length)
    {
      return this.identifiers().map(id =>
        new IntegrationInformation(this.integration(), id),
      );
    }
    else {
      return [];
    }
  });

  constructor(){ }

  ngOnInit(): void {
    // Initialize component state
    // This method is called by parent components and must be present
    this.showProcessDataCardView();
  }


  ngOnDestroy() {
    this.destroyed$.next(undefined);
    this.destroyed$.complete();
  }

  public refreshChildren(): void
  {
    this.showProcessDataCardView();
  }

  public showFastFetchView()
  {
    this.showProcessDataCards.set(false);
    this.showDataSwap.set(false);
    this.showFastFetch.set(true);
  }

  public showDataSwapView()
  {
    this.showProcessDataCards.set(false);
    this.showDataSwap.set(true);
    this.showFastFetch.set(false);
  }

  public showProcessDataCardView()
  {
    this.showProcessDataCards.set(true);
    this.showDataSwap.set(false);
    this.showFastFetch.set(false);
  }
}
